import { useHistory } from "react-router";
import { BreadCrumb, Header } from "@funcional/react-ui";
import { useCreateRegistrationPolicy } from "@pbm/registration-policies/hooks";
import { useCreateAuthenticationExternalApi } from "@pbm/registration-policies/hooks/useCreateAuthenticationExternalApi";
import RegistrationPolicyForm from "@pbm/registration-policies/components/RegistrationPolicyForm";
import { useState } from "react";
import { IGraphQLError } from "@common/contracts";

export default function CreateRegistrationPolicyPage() {
  const [graphQLErrors, setGraphQLErrors] = useState<IGraphQLError[]>([]);
  const { isLoading, isSuccess, mutateAsync } = useCreateRegistrationPolicy();
  const createAuthenticationExternalApi = useCreateAuthenticationExternalApi();

  const history = useHistory();

  const onSubmit = async (input: any) => {
    try {
      // Convert undefineds into falses
      input.requiresRegistration = !!input.requiresRegistration;
      input.requiresPrescription = !!input.requiresPrescription;
      input.requiresContactInformation = !!input.requiresContactInformation;
      input.enabledApiExternal = !!input.enabledApiExternal;

      const formField = {
        id: input?.id,
        description: input?.description,
        requiresRegistration: input?.requiresRegistration,
        requiresPrescription: input?.requiresPrescription,
        requiresContactInformation: input?.requiresContactInformation,
        createdAt: input?.createdAt,
        updatedAt: input?.updatedAt,
        deletedAt: input?.deletedAt,
        allowedOrigins: input?.allowedOrigins,
        formFields: input?.formFields,
        enabledApiExternal: input?.enabledApiExternal,
      };

      const record = await mutateAsync(formField);

      const headerApi = {
        id: input?.id,
        RegistrationPolicyCode: Number(record.id),
        header: [...input?.header],
        form: [...input?.form],
        url: input?.url,
        token: input?.token,
        method: input?.method,
      };

      if (formField.enabledApiExternal === true) {
        await createAuthenticationExternalApi.mutateAsync(headerApi);
      }

      return history.push(`/pbm/registration-policies/${record.id}`);
    } catch (error: any) {
      console.error(error);
      if (error.response.errors) {
        return setGraphQLErrors(error.response.errors || []);
      }
      setGraphQLErrors([
        {
          message:
            "Não foi possível salvar o registro, tente novamente mais tarde.",
        },
      ]);
    }
  };

  return (
    <>
      <Header
        title="Nova Política Cadastral"
        backTo="/pbm/registration-policies"
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            {
              path: "/pbm/registration-policies",
              label: "Políticas Cadastrais",
            },
            { label: "Nova" },
          ]}
        />
      </Header>

      <RegistrationPolicyForm
        graphQLErrors={graphQLErrors}
        isLoading={isLoading || isSuccess}
        onSubmit={onSubmit}
      />
    </>
  );
}
